__turbopack_context__.v({
  "copy": "HeroTextBlock-module-scss-module__4do1pG__copy",
  "heroHeading": "HeroTextBlock-module-scss-module__4do1pG__heroHeading",
  "heroTextBlockContainer": "HeroTextBlock-module-scss-module__4do1pG__heroTextBlockContainer",
  "logoContainer": "HeroTextBlock-module-scss-module__4do1pG__logoContainer",
});
